import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, labelModes, services, states } from '@/utils'

import button from '@/components/button'
import generatorRow from '@/components/generator/row'
import info from '@/components/info'
import RowWithMessageTypeIcon from '@/components/misc/RowWithMessageTypeIcon'
import preloader from '@/components/preloader'
import routesFormLink from '@/components/services/routes/form/link'

const serviceNameViaPoint = services['otp-settings/widgets'].split('/').join('.')

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.infos.user.channels`)
      }
    }
  )
}
function renderWarning(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.warnings.channels`),
        color: Colors.warning
      }
    }
  )
}

function renderChannelField(h, item) {
  return h(
    components.select,
    {
      props: {
        value: item.otpChannelSettingsId,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.channels`),
        service: services['otp-settings/channels'],
        picks: [ 'id', 'name', 'channelType' ],
        itemTitle: 'name',
        itemsDisabled: this.otpChannelsSettings.map(({ otpChannelSettingsId }) => {
          return otpChannelSettingsId
        }),
        labelMode: labelModes.hidden,
        combobox: true,
        dense: true,
        details: false,
        clearable: true,
        disabled: this.disabled || this.restData[services['otp-settings/channels']].find.pagination.total === 0
      },
      on: {
        input: event => {
          item.otpChannelSettingsId = event
        }
      },
      scopedSlots: {
        selection: ({ item }) => {
          return h(
            RowWithMessageTypeIcon,
            {
              props: {
                value: item.channelType,
                title: item.name
              }
            }
          )
        },
        item: ({ item }) => {
          return h(
            RowWithMessageTypeIcon,
            {
              props: {
                value: item.channelType,
                title: item.name,
                as: 'text'
              }
            }
          )
        }
      }
    }
  )
}
function renderLinkToChannel(h, item) {
  if (this.checkPermissions(`advanced.${services['otp-settings/channels'].split('/').join('.')}.create`)) {
    return h(
      routesFormLink,
      {
        props: {
          value: { id: item.otpChannelSettingsId },
          service: services['otp-settings/channels'].split('/').join('.')
        }
      }
    )
  }
}
function renderRow(h, item) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8',
      style: { 'grid-template-columns': '1fr 38px' }
    },
    [
      renderChannelField.call(this, h, item),
      renderLinkToChannel.call(this, h, item)
    ]
  )
}
function renderSaveButton(h) {
  return h(
    'div',
    {
      class: 'fjcfe'
    },
    [
      h(
        button,
        {
          props: {
            icon: 'save',
            label: this.getTranslate('misc.buttons.save'),
            color: Colors.primary,
            mode: buttonModes.flat,
            loading: this.loading,
            disabled: this.loading
          },
          on: {
            click: () => {
              this.attachChannels()
            }
          }
        }
      )
    ]
  )
}
function renderGeneratorRow(h) {
  return h(
    generatorRow,
    {
      props: {
        value: this.otpChannelsSettings,
        disabled: this.disabled || this.restData[services['otp-settings/channels']].find.pagination.total === 0,
        defaultValue: { otpChannelSettingsId: undefined },
        sortable: false
      },
      scopedSlots: {
        row: ({ item }) => {
          return renderRow.call(this, h, item)
        },
        footer: () => {
          return renderSaveButton.call(this, h)
        }
      },
      on: {
        input: event => {
          this.otpChannelsSettings = event
        }
      }
    }
  )
}
function renderContent(h) {
  if (this.restData[services['otp-settings/channels']].find.state === states.loading) {
    return h(preloader)
  }

  if (this.restData[services['otp-settings/channels']].find.state === states.ready) {
    if (this.restData[services['otp-settings/channels']].find.pagination.total === 0) {
      return renderWarning.call(this, h)
    }
  }

  return [
    renderInfo.call(this, h),
    renderGeneratorRow.call(this, h)
  ]
}
function renderChannelsField(h) {
  if (!this.isNew) {
    return h(
      components.card,
      {
        class: 'grid grid-gap--8 pa-2',
        props: {
          title: this.getTranslate(`${serviceNameViaPoint}.titles.channels`),
          rounded: true,
          outline: true,
          dashed: true
        }
      },
      [ renderContent.call(this, h) ]
    )
  }
}

function renderForm(h) {
  return h(
    components.card,
    {
      class: 'ptpx-12 pb-2 px-2',
      props: {
        outline: true,
        rounded: true
      }
    },
    [
      h(
        components.form,
        {
          class: 'grid',
          style: { 'grid-template-columns': '100%' }
        },
        [ renderChannelsField.call(this, h) ]
      )
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 pa-2'
    },
    [ renderForm.call(this, h) ]
  )
}
